import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {finalize, tap} from "rxjs/operators";
import {Injectable} from "@angular/core";

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
  constructor (
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if(!request.url.includes('scadenzario/scadenze/alert'))
    //   this.GlobalStore.updateNotifiche();
    return next.handle(request).pipe(tap(), finalize(() => {}));
  }
}
